import type { LettersData } from '@generated/components/LettersPanel';

type Send = LettersData['sends'][number];

/** Per-person delivery record: "Letter 1 sent Nov 2" / "Letter 2 failed". */
export function SendBadges({ sends, email }: { sends: Send[]; email: string | null | undefined }) {
  const e = (email ?? '').trim().toLowerCase();
  if (!e) return null;
  const mine = sends.filter((s) => (s.to ?? '').trim().toLowerCase() === e).sort((a, b) => a.letterNumber - b.letterNumber);
  if (!mine.length) return <span className="text-[11px] text-muted-foreground">No letters sent yet</span>;
  return (
    <span className="inline-flex flex-wrap gap-1">
      {mine.map((s) => {
        const ok = s.status !== 'failed';
        const day = new Date(s.sentAt).toLocaleDateString('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric' });
        return (
          <span key={`${s.letterNumber}-${s.sentAt}`} className={`border px-1.5 text-[10px] font-semibold uppercase ${ok ? 'border-foreground' : 'border-destructive text-destructive'}`}>
            Letter {s.letterNumber} {ok ? `sent ${day}` : 'failed – will retry on next send'}
          </span>
        );
      })}
    </span>
  );
}
